module.exports = __webpack_public_path__ + "img/new-header.0fd69806.jpg";